module.exports = __webpack_public_path__ + "img/07.ca39673e.png";